<!-- AEO: Marcado Schema para declarar que la organización busca (seeks) socios -->
<section class="section-padding" aria-labelledby="partners-title" itemscope itemtype="https://schema.org/Organization">
  <meta itemprop="name" content="Estancos Distilling Company">

  <div class="container distributors-grid">

    <!-- Columna de Información -->
    <div class="info-column">

      <!-- AEO: Título con intención de búsqueda B2B clara -->
      <h2 id="partners-title">Socios Comerciales y Distribuidores B2B</h2>

      <!-- AEO: Tripletas semánticas iniciales declaradas como una "Demanda/Búsqueda" comercial -->
      <div itemprop="seeks" itemscope itemtype="https://schema.org/Demand">
        <p class="intro-text" itemprop="description">
          <strong>Estancos Distilling Company</strong> busca <strong>socios comerciales y distribuidores</strong> que
          compartan nuestra pasión por la tradición.
          <strong>Nuestra destilería</strong> ofrece <strong>destilados premium para restaurantes, hoteles y
            licorerías</strong> de alto nivel en tu región.
        </p>
      </div>

      <!-- AEO: Transformación de los div genéricos en una lista semántica <ul> -->
      <ul class="benefits-list" aria-label="Beneficios de distribuir nuestros destilados">

        <!-- Beneficio 1 -->
        <li class="benefit-item">
          <div class="benefit-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
            </svg>
          </div>
          <div class="benefit-text">
            <h3>Márgenes Competitivos</h3>
            <!-- Tripleta -->
            <p><strong>Estancos</strong> garantiza <strong>márgenes competitivos y precios preferenciales</strong> por
              volumen para maximizar el retorno de tu inversión.</p>
          </div>
        </li>

        <!-- Beneficio 2 -->
        <li class="benefit-item">
          <div class="benefit-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
          </div>
          <div class="benefit-text">
            <h3>Material de Punto de Venta (POS)</h3>
            <!-- Tripleta -->
            <p><strong>Nuestra marca</strong> provee <strong>material de punto de venta (POS)</strong>, incluyendo
              exhibidores, cristalería oficial y material gráfico destacado.</p>
          </div>
        </li>

        <!-- Beneficio 3 -->
        <li class="benefit-item">
          <div class="benefit-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <div class="benefit-text">
            <h3>Soporte y Capacitación</h3>
            <!-- Tripleta -->
            <p><strong>Nuestro Maestro Destilador</strong> brinda <strong>capacitación directa</strong> para tu equipo
              de ventas, asegurando una atención técnica y personalizada.</p>
          </div>
        </li>
      </ul>
    </div>

    <!-- Columna del Formulario Reactivo -->
    <div class="form-column">

      @if (isSubmitted) {
      <!-- Estado de Éxito -->
      <div class="success-message" role="alert" aria-live="polite">
        <h3>¡Solicitud Recibida!</h3>
        <p>Gracias por tu interés en representar a Estancos. Nuestro equipo comercial revisará tu perfil y se pondrá en
          contacto contigo a la brevedad.</p>
      </div>
      } @else {
      <!-- Formulario -->
      <div class="form-header">
        <h3 id="form-title">Envía tu Solicitud de Distribución</h3>
        <p>Completa tus datos comerciales a continuación.</p>
      </div>

      @if (submitError) {
      <div class="error-toast" role="alert" aria-live="assertive">
        {{ submitError }}
      </div>
      }

      <!-- AEO/Accesibilidad: Formulario vinculado a su título mediante aria-labelledby -->
      <form [formGroup]="distributorForm" (ngSubmit)="onSubmit()" aria-labelledby="form-title">

        <!-- HONEYPOT (Trampa para bots) -->
        <div class="form-group" style="display: none;" aria-hidden="true">
          <label for="website_url">Website URL (No llenar)</label>
          <input type="text" id="website_url" formControlName="website_url" tabindex="-1" autocomplete="off">
        </div>

        <div class="form-group">
          <label for="name">Nombre Completo <span class="required-mark" aria-label="requerido">*</span></label>
          <input type="text" id="name" formControlName="name" placeholder="Ej. Carlos Mendoza"
            [class.is-invalid]="isFieldInvalid('name')" autocomplete="name">
          @if (distributorForm.get('name')?.touched && distributorForm.get('name')?.hasError('required')) { <span
            class="error-message" role="alert">El nombre es obligatorio.</span> }
          @if (distributorForm.get('name')?.touched && distributorForm.get('name')?.hasError('pattern')) { <span
            class="error-message" role="alert">Solo se permiten letras y espacios.</span> }
          @if (distributorForm.get('name')?.touched && distributorForm.get('name')?.hasError('minlength')) { <span
            class="error-message" role="alert">Mínimo 3 caracteres.</span> }
        </div>

        <div class="form-group">
          <label for="company">Empresa / Razón Social <span class="required-mark"
              aria-label="requerido">*</span></label>
          <input type="text" id="company" formControlName="company" placeholder="Ej. Distribuidora Andina S.A."
            [class.is-invalid]="isFieldInvalid('company')" autocomplete="organization">
          @if (distributorForm.get('company')?.touched && distributorForm.get('company')?.hasError('required')) { <span
            class="error-message" role="alert">El nombre de la empresa es obligatorio.</span> }
          @if (distributorForm.get('company')?.touched && distributorForm.get('company')?.hasError('minlength')) { <span
            class="error-message" role="alert">Mínimo 3 caracteres.</span> }
        </div>

        <div class="form-group">
          <label for="email">Correo Electrónico Comercial <span class="required-mark"
              aria-label="requerido">*</span></label>
          <input type="email" id="email" formControlName="email" placeholder="ejemplo@tuempresa.com"
            [class.is-invalid]="isFieldInvalid('email')" autocomplete="email">
          @if (distributorForm.get('email')?.touched && distributorForm.get('email')?.hasError('required')) { <span
            class="error-message" role="alert">El correo electrónico es obligatorio.</span> }
          @if (distributorForm.get('email')?.touched && distributorForm.get('email')?.hasError('email') ||
          distributorForm.get('email')?.hasError('pattern')) { <span class="error-message" role="alert">Ingresa un
            formato de correo válido.</span> }
        </div>

        <div class="form-group">
          <label for="region">Región / Ciudad de Operación <span class="required-mark"
              aria-label="requerido">*</span></label>
          <input type="text" id="region" formControlName="region" placeholder="Ej. Quito, Pichincha"
            [class.is-invalid]="isFieldInvalid('region')">
          @if (distributorForm.get('region')?.touched && distributorForm.get('region')?.hasError('required')) { <span
            class="error-message" role="alert">La región o ciudad es obligatoria.</span> }
          @if (distributorForm.get('region')?.touched && distributorForm.get('region')?.hasError('minlength')) { <span
            class="error-message" role="alert">Mínimo 4 caracteres.</span> }
        </div>

        <div class="form-group">
          <label for="message">Mensaje (Opcional)</label>
          <textarea id="message" formControlName="message"
            placeholder="Cuéntanos un poco sobre tu red de distribución o experiencia en el sector..."
            rows="4"></textarea>
          @if (distributorForm.get('message')?.touched && distributorForm.get('message')?.hasError('minlength')) { <span
            class="error-message" role="alert">Por favor, danos un poco más de detalle (mínimo 15 caracteres).</span> }
        </div>

        <button type="submit" class="btn-submit" [disabled]="distributorForm.invalid || isSubmitting">
          {{ isSubmitting ? 'Procesando...' : 'Enviar Solicitud' }}
        </button>

      </form>
      }
    </div>

  </div>
</section>